import RichText from "@/components/RichText";
import MutedVideo from "../components/MutedVideo";
import { CONTAINER, DARK_BG, EYEBROW_LIGHT } from "../tokens";

// « L'atelier en images » : tuiles 4/3 (minmax 240px, gouttière 16px). Une
// tuile joue sa vidéo (muette, en boucle) si elle en a une, sinon sa photo ;
// vide, elle garde le fond sombre de la maquette.
export default function GallerySection({ props = {}, blocks = [] }) {
  const tiles = (blocks || []).filter((b) => b.type === "gallery_item" && b.enabled !== false);
  if (!tiles.length) return null;

  return (
    <section>
      <div className={`${CONTAINER} px-5 md:px-11 py-14`}>
      <RichText as="div" className={`${EYEBROW_LIGHT} mb-[26px]`} html={props.eyebrow} />
      <div className="grid [grid-template-columns:repeat(auto-fit,minmax(240px,1fr))] gap-4">
        {tiles.map((b) => {
          const p = b.props || {};
          return (
            <div key={b.id} data-block-key={b.id} className="aspect-[4/3] overflow-hidden" style={DARK_BG}>
              {p.video_url ? (
                <MutedVideo src={p.video_url} poster={p.image_url} className="w-full h-full object-cover block" />
              ) : p.image_url ? (
                <img src={p.image_url} alt={p.alt || ""} className="w-full h-full object-cover block" loading="lazy" />
              ) : null}
            </div>
          );
        })}
      </div>
      </div>
    </section>
  );
}
